var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2314_1316)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2966 17.5094L21.7133 10.874C21.3049 10.5166 20.695 10.5166 20.2865 10.874L12.7032 17.5094C12.4681 17.7151 12.3333 18.0123 12.3333 18.3247V27.5831C12.3333 28.1814 12.8183 28.6665 13.4166 28.6665H17.7499C18.3482 28.6665 18.8333 28.1814 18.8333 27.5831V23.2498C18.8333 22.6515 19.3183 22.1665 19.9166 22.1665H22.0833C22.6816 22.1665 23.1666 22.6515 23.1666 23.2498V27.5831C23.1666 28.1814 23.6516 28.6665 24.2499 28.6665H28.5833C29.1816 28.6665 29.6666 28.1814 29.6666 27.5831V18.3247C29.6666 18.0123 29.5317 17.7151 29.2966 17.5094Z",
    stroke: "#037968",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2314_1316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.04a81fc59161e2f163ea3fc1cf4ef843.svg";
export { ForwardRef as ReactComponent };